import { render, staticRenderFns } from "./CreatorRequestDisputeView.vue?vue&type=template&id=2f377783&"
import script from "./CreatorRequestDisputeView.vue?vue&type=script&lang=js&"
export * from "./CreatorRequestDisputeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports